export class ClassData {
  _id: string;
  name: string;
  count: number;
  grade: string;
}

export interface Year {
  _id: string;
  name: string;
  number: number;
  category?: string;
  description?: string;
}

export interface Grade {
  _id: string;
  name: string;
  year_id?: string;
  year: Year;
  yera_no?: string;
  project_id?: string;
}